import { useState, useEffect, useRef } from "react";
import { FormField } from '@prosolve/common-components-ui'
import useDataImplementations from '../dataHooks/useDataImplementations'

export default ({
  formData
}) => {
  const { fetchImplementations } = useDataImplementations()

  const [loading, setLoading] = useState(true);
  const [searchVal, setSearchVal] = useState('')
  const [implementations, setImplementations] = useState([])

  const fetchImplementationsData = async () => {
    setLoading(true)
    try {
      const implementationsData = await fetchImplementations(formData.values.accountId) || []
      setImplementations(implementationsData)
    } catch (e) {
      console.log(e)
      setImplementations([])
    }
    setLoading(false)
  }

  const selectorRef = useRef()

  useEffect(() => {
    formData.setValues({ ...formData.values, implementationId: '' })
    if (selectorRef.current && selectorRef.current.clearInput) {
      selectorRef.current.clearInput()
    }
    fetchImplementationsData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.accountId])

  const options = implementations
    .filter(({ Name }) => Name.toLowerCase().indexOf(searchVal.toLowerCase()) > -1)
    .map(({ Id, Name }) => ({ value: Id, text: Name }))

  if (searchVal === '') {
    options.unshift({ value: '', text: '', display: 'All' })
  }

  return (
    <FormField
      ref={selectorRef}
      style={{ flex: 1 }}
      width='100%'
      fieldId='implementationId'
      type='search'
      label='School'
      formData={formData}
      options={options}
      suppressAutoClearOnFocus={true}
      isLoading={loading}
      onSearch={(val) => { setSearchVal(val) }}
      placeholder='All'
      maxHeight='200px'
    />
  )
}